import { render } from "./MultipleChoiceCheckboxes.vue?vue&type=template&id=6d7cd688&scoped=true"
import script from "./MultipleChoiceCheckboxes.vue?vue&type=script&lang=js"
export * from "./MultipleChoiceCheckboxes.vue?vue&type=script&lang=js"

import "./MultipleChoiceCheckboxes.vue?vue&type=style&index=0&id=6d7cd688&lang=scss&scoped=true"

import exportComponent from "/app/tmp/360pt/V3/v2026.28.r0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d7cd688"]])

export default __exports__